<div [class.show]="showPreloader()" class="page-preloader">
    <div class="loader-image"></div>
</div>

<!-- blocks: before -->
<app-blocks-wrapper context="exhibitions" placement="before"></app-blocks-wrapper>

<div *ngIf="_currentExhibitions && _currentExhibitions?.length" class="container exhibition-main">
    <article *ngFor="let currentExhibition of _currentExhibitions; let eIndex = index" class="row exhibition-row">
        <div class="col-12 col-lg-6 d-lg-none exhibition-main-content">
            <header class="article-header exhibition-article-title">
                <small
                    class="header-small-text exhibition-label styled-header">{{ 'exhibitions.current-exhibition' | translate:urlService.lang }}</small>

                <div class="exhibition-title">
                    <a [ngClass]="{'with-underline':activeTextElementsOnHoverEnabled, 'hoverable-element':true}"
                       [queryParams]="{
                        offset:(eIndex+1)
                    }"
                       [routerLink]="[urlService.link('exhibitions', currentExhibition)]">{{ currentExhibition.name[urlService.langCode] }}</a>
                </div>

                <p *ngIf="currentExhibition.date_from && currentExhibition.date_to" class="exhibition-time">
                    <span
                        *ngIf="currentExhibition.date_from">{{ currentExhibition.date_from | localizedDate:'dd.MM.yyyy' }}</span>
                    <span
                        *ngIf="currentExhibition.date_to"> &ndash; {{ currentExhibition.date_to | localizedDate:'dd.MM.yyyy' }}</span>
                </p>
            </header>
        </div>

        <div class="col-12 col-lg-6 order-lg-2 exhibition-figure-wrapper">

            <a [queryParams]="{
                offset:(eIndex+1)
            }" [routerLink]="[urlService.link('exhibitions', currentExhibition)]" class="exhibition-link">
                <span [ngStyle]="{
                    'background-image':'url('+(
                        _imagesTypes[eIndex] === 'object' && currentExhibition.image !== null && currentExhibition.image.thumbnails
                            ? currentExhibition.image?.thumbnails?.original.url
                            : 'assets/images/placeholder-600x450.jpg'
                    )+')'
                }" class="exhibition-figure"></span>

                <!-- <img appLazyLoad src="{{ currentExhibition.image?.thumbnails?.medium ? currentExhibition.image?.thumbnails?.medium.url : currentExhibition.image?.thumbnails?.original.url }}" class="exhibition-figure img-fluid" alt="{{ currentExhibition.name[urlService.langCode] }}" /> -->
                <!-- <img appLazyLoad src="assets/images/placeholder-600x450.jpg" class="exhibition-figure img-fluid" alt="{{ currentExhibition.name[urlService.langCode] }}" /> -->
            </a>

        </div>

        <div class="col-12 col-lg-6 order-lg-1 exhibition-main-content">
            <div class="article-header exhibition-article-title d-none d-lg-block">
                <!-- duplikacja, niestety -->
                <small
                    class="header-small-text exhibition-label styled-header">{{ 'exhibitions.current-exhibition' | translate:urlService.lang }}</small>

                <p class="exhibition-title">
                    <a [ngClass]="{'with-underline':activeTextElementsOnHoverEnabled, 'hoverable-element':true}"
                       [queryParams]="{
                        offset:(eIndex+1)
                    }"
                       [routerLink]="[urlService.link('exhibitions', currentExhibition)]">{{ currentExhibition.name[urlService.langCode] }}</a>
                </p>

                <p *ngIf="currentExhibition.date_from && currentExhibition.date_to" class="exhibition-time">
                    <span
                        *ngIf="currentExhibition.date_from">{{ currentExhibition.date_from | localizedDate:'dd.MM.yyyy' }}</span>
                    <span
                        *ngIf="currentExhibition.date_to"> &ndash; {{ currentExhibition.date_to | localizedDate:'dd.MM.yyyy'}}</span>
                </p>
            </div>

            <div [innerHTML]="description(currentExhibition)"></div>
            <div class="show-more-button-wrapper">
                <a (click)="toggleDescription()" *ngIf="cutDescription"
                   class="show-more-button">{{getExpandText[urlService.lang]}}</a>
            </div>

            <footer class="exhibition-main-footer row align-items-end">
                <div class="col-12 col-sm-3 col-lg-3 col-xl-2 order-1 order-sm-3 exhibition-more-wrapper">
                    <a [queryParams]="{
                        offset:(eIndex+1)
                    }" [routerLink]="[urlService.link('exhibitions', currentExhibition)]"
                       class="btn exhibition-more">{{ 'general.more' | translate:urlService.lang }}</a>
                </div>

                <div class="col-12 col-sm-9 col-lg-9 col-xl-10 order-2 order-sm-1">
                    <div class="socials-share exhibitions-aside-share">

                        <app-social-share #socialShare (emailClick)="openRecommendationModal(eIndex)"
                                          [url]="currentExhibition.url"></app-social-share>

                    </div>
                </div>
            </footer>
        </div>
    </article>

    <app-paginator collection="current-exhibitions"></app-paginator>

    <div *ngIf="settings.items_per_page_change_enabled" [class.no-pagination]="! hasPagination"
         class="works-per-page-dropdown">
        <app-per-page-dropdown #perPageDropdown [collection]="'current-exhibitions'"
                               [defaultValue]="settings.items_per_page"
                               [options]="{clickOpen:true}"></app-per-page-dropdown>
    </div>

    <app-modal-form #recommendationModal *ngIf="_recommendedObject"
                    [object]="_recommendedObject" [options]="{type:'recommend', what:'exhibition'}"></app-modal-form>
</div>

<div *ngIf="_archive && _archive?.length" class="container">
    <section class="exhibition-content-section">
        <div class="row">
            <div class="col-12 col-sm-8">
                <div
                    class="section-title exhibitions-archive-title styled-header">{{ 'exhibitions.Archive' | translate:urlService.lang }}</div>
            </div>

            <div class="col-12 col-sm-4">
                <div class="sort-exhibitions-dropdown dropdown">
                    <app-dropdown-sort [title]="'general.sort' | translate:urlService.lang"
                                       collection="exhibitions-archive"></app-dropdown-sort>
                </div>
            </div>
        </div>

        <div class="no-masonry">
            <div *ngFor="let exhibition of _archive; let eIndex = index"
                 [ngClass]="{'no-zoom': !zoomImages, 'four-columns': isFourColumns === 'true', 'three-columns': isFourColumns !== 'true'}"
                 class="masonry-grid-item grid-sizer">
                <article class="exhibitions-list-article">
                    <div class="exhibition-figure-wrapper">
                        <a [queryParams]="{
                            offset:(eIndex+1)
                        }" [routerLink]="[urlService.link('exhibitions', exhibition)]"
                           class="exhibition-link exhibition-image-link">

                            <img alt="{{ exhibition.name[urlService.langCode] }}" appLazyLoad
                                 class="img-fluid exhibition-figure"
                                 src="{{
                                exhibition.image?.url
                                    ? exhibition.image?.url
                                    : (exhibition.images?.length > 0
                                        ? exhibition.images[0]?.thumbnails?.medium.url
                                        : 'assets/images/placeholder-450x340.jpg'
                                    )
                            }}"/>

                        </a>
                    </div>

                    <div class="exhibition-title">
                        <a [ngClass]="{'with-underline':activeTextElementsOnHoverEnabled, 'hoverable-element':true}"
                           [queryParams]="{
                            offset:(eIndex+1)
                        }"
                           [routerLink]="[urlService.link('exhibitions', exhibition)]"
                           class="exhibition-link">{{ exhibition.name[urlService.langCode] }}</a>
                    </div>

                    <p *ngIf="exhibition.date_from" class="exhibition-time">
                        <span
                            *ngIf="exhibition.date_from">{{ exhibition.date_from | localizedDate:'dd.MM.yyyy' }}</span>
                        <span
                            *ngIf="exhibition.date_to"> &ndash; {{ exhibition.date_to | localizedDate:'dd.MM.yyyy' }}</span>
                    </p>
                </article>
            </div>
        </div>

        <app-paginator collection="exhibitions-archive"></app-paginator>
    </section>
</div>

<!-- blocks: after -->
<app-blocks-wrapper context="exhibitions" placement="after"></app-blocks-wrapper>
